import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

import { Button } from "./ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

interface PaginationProps {
  pages: number;
  items: number;
  page: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

export function Pagination({
  page,
  pages,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) {
  function firstPage() {
    if (page === 1) return;
    onPageChange(1);
  }

  function previousPage() {
    if (page <= 1) return;
    onPageChange(page - 1);
  }

  function nextPage() {
    if (page >= pages) return;
    onPageChange(page + 1);
  }

  function lastPage() {
    if (page === pages) return;
    onPageChange(pages);
  }

  return (
    <div className="flex items-center justify-between text-sm text-zinc-500">
      <div className="flex items-center gap-x-2">
        <Select
          defaultValue="8"
          onValueChange={(value) => onPageSizeChange(Number(value))}
        >
          <SelectTrigger aria-label="Page">
            <SelectValue placeholder="8" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="8">8</SelectItem>
            <SelectItem value="16">16</SelectItem>
            <SelectItem value="32">32</SelectItem>
          </SelectContent>
        </Select>
        <span>per page</span>
      </div>
      <div className="flex items-center gap-8">
        <span>
          Page {page} of {pages}
        </span>

        <div className="space-x-1.5">
          <Button size="sm" disabled={page === 1} onClick={firstPage}>
            <ChevronsLeft className="size-4" />
            <span className="sr-only">First page</span>
          </Button>
          <Button size="sm" disabled={page === 1} onClick={previousPage}>
            <ChevronLeft className="size-4" />
            <span className="sr-only">Previous page</span>
          </Button>
          <Button size="sm" disabled={page === pages} onClick={nextPage}>
            <ChevronRight className="size-4" />
            <span className="sr-only">Next page</span>
          </Button>
          <Button size="sm" disabled={page === pages} onClick={lastPage}>
            <ChevronsRight className="size-4" />
            <span className="sr-only">Last page</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
